<template lang="pug">
v-container(fluid) 
    v-card(color="#3557A5")  
        v-card-title(style="color:white") NO CONFORMIDADES - PENDIENTES DE CIERRE
        v-divider
        v-container(fluid)
            v-row  
                v-spacer
                v-col(cols=12 sm=12 md=2  style="min-width:200px!important")                                     
                    v-tooltip(bottom) 
                        template(v-slot:activator="{ on, attrs }")
                            v-card(height='100%'  v-bind="attrs" v-on="on" color="success"  dark).text-xs-center         
                                v-card-text     
                                    .display-1.mb-2 {{dtItems.length}}
                                    |  Cantidad No Conformidades 
                        span No Conformidades Generadas en el trascurso del año 
                v-col(cols=12 sm=12 md=2 style="min-width:200px!important")   
                    v-tooltip(bottom) 
                        template(v-slot:activator="{ on, attrs }")
                            v-card(height='100%'  v-bind="attrs" v-on="on" color="primary" dark @click="filterNext=filterNext==null ? 0:null; filterExpired=null;").text-xs-center         
                                v-card-text     
                                    .display-1.mb-2  {{dtItems.filter(b=> (b.Day>0)).length}}
                                    | Por Vencer  
                        span No Conformidades por vencer
                v-col(cols=12 sm=12 md=2  style="min-width:200px!important")   
                    v-tooltip(bottom) 
                        template(v-slot:activator="{ on, attrs }")
                            v-card(height='100%'  v-bind="attrs" v-on="on" color="red" dark @click="filterExpired=filterExpired==null ? 0:null;filterNext=null;" ).text-xs-center         
                                v-card-text     
                                    .display-1.mb-2  {{dtItems.filter(b=>b.Day<0).length}}
                                    |  Fuera de Plazo 
                        span No Conformidades fuera de plazo
        v-container(fluid)
            v-toolbar(flat)
                v-toolbar-title              
                v-spacer
                v-text-field(
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details)
            v-toolbar(flat)
                v-toolbar-title
                    v-container(fluid)
                        v-row
                            v-col
                                v-autocomplete(  
                                                :items="columnValueList('TypeDocument')"
                                                hide-details="auto"
                                                v-model="filters['TypeDocument']"
                                                clearable
                                                dense
                                                label="Documento"
                                                outlined)
                            v-col
                                v-autocomplete(  
                                                :items="columnValueList('NumberDocument')"
                                                hide-details="auto"
                                                v-model="filters['NumberDocument']"
                                                clearable
                                                dense
                                                label="N°"
                                                outlined)
                            v-col
                                v-autocomplete(  
                                                :items="columnValueList('Category')"
                                                hide-details="auto"
                                                v-model="filters['Category']"
                                                clearable
                                                dense
                                                label="Categoria"
                                                outlined)  
                            v-col 
                                v-autocomplete(  
                                                :items="columnValueList('Responsible')"
                                                hide-details="auto"
                                                v-model="filters['Responsible']"
                                                clearable
                                                dense
                                                label="Responsable"
                                                outlined)      
                            v-col   
                                v-btn(  
                                        class="ma-2"
                                        color="success"
                                        dark
                                        @click="GetDownloadReport()")
                                    v-icon  mdi-cloud-download   
            v-data-table(:headers="dtHead"
                        dense
                        :items="ItemsFilters.filter(b => (filterNext==null && filterExpired==null) || (filterExpired!=null && b.Day<0) || (filterNext!=null && b.Day>=0) )",
                        :items-per-page="50" 
                        class="elevation-3" 
                        item-key="Id"  
                        :search="search"
                        :loading="dtLoading"
                        loading-text="Cargando Informacion......"
                        height="500"
                        class="elevation-2"
                        fixed-header
                        fixed-append)  
                template(v-slot:top="{top}") 
                               
                template( v-slot:item.DateFinish="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        | {{ item.DateFinish | formatDate }}               
                template( v-slot:item.TypeDocument="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;padding-top: 5px!important;")  
                        v-chip(color="success" outlined) {{item.TypeDocument}}  
                template( v-slot:item.action="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        v-row             
                            v-btn(icon  color="success"  @click="Closed(item.IdDocumentDetails)" )
                                v-icon mdi-lock-check 
                            v-btn(icon  color="primary"  @click="Create_PDF(item.IdDocument,item.IdDocType)" )
                                v-icon mdi-file-pdf-box
                template( v-slot:item.Day="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;padding-top: 5px!important;")  
                        v-chip(v-if="item.Day>=0" color="success" outlined) {{item.Day}} 
                        v-chip(v-else color="error" outlined) {{item.Day}}  
                template( v-slot:item.img="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        v-row             
                            v-btn(icon   @click="OpenImg(item.IdDocumentDetails)" )
                                v-icon mdi-image 
        v-dialog(v-if="modelImg" 
                v-model="modelImg"
                width="400" 
                transition="dialog-bottom-transition" )

            v-card(style="width:400px") 
                v-toolbar(flat) 
                    v-spacer 
                    v-btn(icon @click="modelImg=false" )
                        v-icon mdi-close  
                v-container(fluid)       
                    v-img( width="300" 
                            :src="'data:image/jpg;base64,'+ itemSelect.Img.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,','')"  
                            cover
                            ) 
        v-dialog(v-if="modelClose" 
                v-model="modelClose"
                width="600" 
                transition="dialog-bottom-transition" )

                v-card(v-if="itemSelect")
                    v-card-title(style="background-color: #3557A5; color:white") N° {{itemSelect.IdDocument}} 
                        v-spacer
                        v-btn(icon @click="modelClose=false" style="color:white")
                            v-icon mdi-close
                    v-container(fluid)   
                        v-row 
                            v-col(cols=12 md=12 sm=12) 
                                v-row 
                                    v-col(cols=12 md=1 sm=1 style="text-align:right") 
                                        v-icon(x-large color="orange") mdi-alert
                                    v-col(cols=12 md=5 sm=12 style="text-align:left") 
                                        h6 Recuerde revisar antes de cerrar la no conformidad, una vez realizado este proceso no podra revertirse
                                    v-col(cols=12 md=2 sm=12 style="text-align:left")
                                        v-text-field( 
                                            label="Fecha Cierre"                                
                                            :value="itemSelect.DateFinish | formatDate"
                                            readonly
                                            
                                            hide-details="auto")
                                    v-col(cols=12 md=4 sm=12 style="text-align:left")
                                        v-text-field(
                                                v-model="itemSelect.Responsible"
                                                label="Responsable"
                                                readonly                                 
                                                hide-details="auto")  
                                v-row 
                                    v-col(cols=12 md=4 sm=12 style="text-align:right;font-weight: bold;") 
                                        | Pregunta : 
                                    v-col(cols=12 md=8 sm=12 style="text-align:left") 
                                        | {{itemSelect.Question}}
                                v-row 
                                    v-col(cols=12 md=4 sm=12 style="text-align:right;font-weight: bold;") 
                                        | Observacion : 
                                    v-col(cols=12 md=8 sm=12 style="text-align:left") 
                                        | {{itemSelect.Observation}}
                                v-row 
                                    v-col(cols=12 md=4 sm=12 style="text-align:right;font-weight: bold;") 
                                        | Imagen : 
                                    v-col(cols=12 md=8 sm=12 style="text-align:left") 
                                        v-btn(icon   @click="modelImg=true" )
                                            v-icon mdi-image
                                v-row 
                                    v-col(cols=12 md=4 sm=12 style="text-align:right;font-weight: bold;") 
                                        | Comentario : 
                                    v-col(cols=12 md=8 sm=12 style="text-align:left") 
                                         v-textarea(v-model="parameterClousureInsert.ObservationClousure" outlined)
                                v-row 
                                    v-col(cols=12 md=4 sm=12 style="text-align:right;font-weight: bold;") 
                                        | Foto(png/jpg) : 
                                    v-col(cols=12 md=8 sm=12 style="text-align:left") 
                                        input.form-control.form-control-sm(@change="CaptureImg",type="file", accept="image/*")  
                                v-row
                                    v-col(cols=12 md=12 sm=12 style="text-align:center;font-weight: bold;")
                                        v-btn(color="primary" @click="Clousure()") Cierre
        vue-html2pdf(
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :paginate-elements-by-height="750"
            filename="hee hee"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="letter"
            pdf-orientation="landscape"
            pdf-content-width="800px"
            pdf-unit="in" 
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf")
            section( slot="pdf-content")
                section( class="pdf-item")
                    formatpdf(:tableInfoDetalis="tableInfoDetalis" :IdEnterprise="IdEnterprise" :DocumentSelect="DocumentSelect")
                section( class="pdf-item" v-for="item of tableInfoDetalis.filter(b=> b.answer=='NO')") 
                    span(class="break-page") 
                    anexoPdf(:item="item"  :DocumentSelect="DocumentSelect")                             
</template>
<script>  
import apiWeb from "../../../../api/apiSLC.js"
import modelClousure from "../../../../models/documentDetailsClousure.js" 
import * as XLSX from 'xlsx/xlsx.mjs'
import VueHtml2pdf from 'vue-html2pdf'
import formatpdf from "./formatPdf"
import anexoPdf from "./anexoPdf"
export default {
    components : { 
        VueHtml2pdf,
        formatpdf,
        anexoPdf
    },
    props:['refresh'],
    watch:{
        refresh(value,old){
            if(value!=old){
                console.log(value)
                console.log(old)
                this.GetList()
            }
            
        }
    },
    data(){
        return{ 
            modelImg:false,
            modelClose:false,
            parameterClousureInsert:Object.assign({}, modelClousure.parameterInsert),
            itemSelect:{},
            IdEnterprise:this.$info.idEnterprise,
            dtItems:[],
            search:'', 
            filterNext:null,
            filterExpired:null,
            Img:'',        
            dtLoading:true,
            tableInfoDetalis:[],
            DocumentSelect:{},
            Indicadores:'',
            filters:{},
            tableHeadPdf:[],
            dtHead:[                    
                    { text: "Cierre", value: "action",   width:"10" ,   cellClass:'topStyle',class: 'topStyle'}, 
                    { text: "N° Documento", value: "NumberDocument",  width:"50",  cellClass:'topStyle', class: 'topStyle'},
                    { text: "Documento", value: "TypeDocument",  width:"100",  cellClass:'topStyle', class: 'topStyle'},
                    { text: "Categoria", value: "Category",  width:"100",  cellClass:'topStyle', class: 'topStyle'},
                    { text: "Grupo", value: "GroupQuestions",  width:"100",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Pregunta", value: "Question",  width:"200" ,    cellClass:'topStyle',class: 'topStyle'},
                    { text: "Observacion", value: "Observation",  width:"200" ,   cellClass:'topStyle',class: 'topStyle'},                    
                    { text: "Responsable", value: "Responsible",  width:"100",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Img", value: "img",   width:"10" ,   cellClass:'topStyle',class: 'topStyle'}, 
                    { text: "Fecha de Cierre", value: "DateFinish",  width:"50",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Atraso (Dias)", value: "Day",  width:"50",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Select02", value: "FieldSelect_02",  width:"100",  cellClass:'topStyle', class: 'topStyle'},
                    { text: "Select21", value: "FieldSelect_21",  width:"100",  cellClass:'topStyle', class: 'topStyle'}
                    ], 
        }
    },
    mounted(){
        this.GetList() 
    },
    computed: {
        ItemsFilters() {
        return this.dtItems.filter(d => {
            return Object.keys(this.filters).every(f => {  
                if(this.filters[f]==null)
                    return true
                else{ 
                    if(d[f]!=null)
                        return this.filters[f].toString().length < 1 || this.filters[f].toString().includes(d[f].toString())
                    else
                        return false
                }})
        })
        }   
    },
    methods:{
        CaptureImg(e){
            const selectImage=e.target.files[0];
            this.CreateBase64Image(selectImage)

        },
        CreateBase64Image(fileObjet)
        {
            const reader= new FileReader();
            reader.onload=(e) => {
                this.parameterClousureInsert.ImgClousure=e.target.result;
            };
            reader.readAsDataURL(fileObjet);
        },
        columnValueList(val) {
            return this.ItemsFilters.map(d => d[val])
        },
        OpenImg(docentry){ 
            let form = {
                IdDocumentDetails:docentry  
            }
            apiWeb.post("NonConformities/NonConformities_Img",form,true).then( result => {
                if(result.status==0){
                    let _result=JSON.parse(result.value)
                    this.itemSelect=_result[0]
                    this.modelImg=true
                }   
                    
               
            })
        },
        Closed(docentry){ 
            let form = {
                IdDocumentDetails:docentry  
            }
            apiWeb.post("NonConformities/NonConformities_Img",form,true).then( result => {
                if(result.status==0){
                    let _result=JSON.parse(result.value)
                    
                    this.itemSelect=_result[0]
                    this.parameterClousureInsert.IdDocumentDetails=docentry
                    this.modelClose=true
                }   
                    
               
            })
        },
        Clousure( ){
          if(this.parameterClousureInsert.ObservationClousure!="" )
          {
              this.parameterClousureInsert.User=this.$info.email;
                this.$msgbox.confirm("Esta Seguro de generar el cierre?","Aviso")
                        .then(r=>{
                            if(r){
                                    apiWeb.post("DocumentDetails/DocumentDetails_NON_CONFORMING_Clousure/",this.parameterClousureInsert)
                                                .then(result=>{
                                                        if(result.status==0){
                                                            this.modelClose=false;
                                                            this.$msgbox.show("Pregunta Cerrada","OK")                             
                                                            this.GetList();                           
                                                        }
                                                        else{
                                                            this.$msgbox.show(result.message,"Error nivel 1")
                                                        }
                                                    })
                                                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")}) 
                                                                }
                                    })
          }
          else{
              this.$msgbox.show("No se puede Cerrar, si no hay Observacion ni Imagen","Error nivel 1")
          }
            
        },  
        GetList(){ 
            this.dtLoading=true 
            let form = {
                IdEnterprise:this.$info.idEnterprise  ,
                User:this.$info.email,
            }
            apiWeb.post("NonConformities/NonConformities_Pending",form,false).then( result => {
                if(result.status==0)   
                    this.dtItems=JSON.parse(result.value)
                this.dtLoading=false
            })
        },  
        GetDownloadReport(){ 
            let form = {
                    IdEnterprise:this.$info.idEnterprise  ,
                    User:this.$info.email,
                }
                apiWeb.post("NonConformities/NonConformities_Pending",form,true)
                        .then(element=>{
                            if(element.status==0)   
                                this.DownloadExcel(JSON.parse(element.value),'Reporte Pendientes')

                        })
        },
        DownloadExcel(Info,title){
            var ws = XLSX.utils.json_to_sheet(Info);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, title);
            XLSX.writeFile(wb, title + ".xlsx");
        },
        Create_PDF(IdDocument, IdDocType){ 
            let form={
                IdDocument:IdDocument,
                IdDocType:IdDocType
            }
            apiWeb.get("Report/ReportDocumentId/" + form.IdDocument + "/" + form.IdDocType,"")
                    .then(result=>{
                                if(result.status==0){
                                    this.DocumentSelect=JSON.parse(JSON.stringify(result.value))[0]
                                    console.log(this.DocumentSelect)
                                    this.List_Info_Detalis_PDF()
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                            })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Info_Detalis_PDF(){               
            this.tableHeadPdf=Object.keys(this.DocumentSelect)    
            apiWeb.get("Report/ReportDocumentDetails/"+ this.DocumentSelect.idDocument,"")
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfoDetalis=JSON.parse(JSON.stringify(result.value))  
                                    
                                    if( this.tableInfoDetalis.length>0)
                                    {
                                    // this.tableInfoDetalis.forEach(element => {
                                    //         element.update=0
                                    //     });
                                       this.tableHeadDetalis=Object.keys(this.tableInfoDetalis[0])  
                                       this.generateReport(this.DocumentSelect.category + '_'+this.DocumentSelect.numero)      
                                    }                                   
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        generateReport (name) {
             
             this.$refs.html2Pdf.htmlToPdfOptions= { margin:       [5, 0, 30, 0],  filename: name + '.pdf',pageBreak: { mode: 'css', after:'.break-page'}}
             this.$refs.html2Pdf.generatePdf()
         },
    }
}

</script>
<style >
.colorTest{
    background-color:#0099CC!important;
    color:white!important;
}
.topStyle{
    padding-top: 5px!important;
    vertical-align: text-top!important;
} 
</style>